//export const headerBackgroundColor = "#BEDCFE";
export const headerBackgroundColor = "#EDEDED";
